import { Grid } from "../core/components/grid";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar";
import { ServiceReportCompletion, ServiceReportCompletionAppProps } from "./serviceReportCompletion";
import { EntityServiceReportDistributableHours, ServiceReportUtil } from "./serviceReportUtil";
import { Helper } from "../core/util/helper";
import { General } from "../../siteManagement/general";
import { NotificationHelper } from "../core/util/notificationHelper";
import { DialogHelper } from "../core/util/dialogHelper";
import { Config } from "../core/config/config";
import { Entity } from "../core/components/commonApp";
import React from "react";
export default class ServiceReportCompletionGrid extends React.Component<any, any> {
    private _serviceCompletion: ServiceReportCompletion = null;
    private _distGridRef: Grid = null;
    private _distributable: Array<EntityServiceReportDistributableHours> = [];
    private _icuh = Helper;
    private _updateRequired = false;
    private _tmpTimesAsString = null;


    private _initGridsData = () => {
        const grouped = ServiceReportUtil.groupTimesPerDay(this.props.entity.Times);
        const distCache = ServiceReportUtil.getAlreadyDistributedTimes(this.props.entity.AccomplishedWorks);
        const availableCache = ServiceReportUtil.getDistributableTimes(grouped, distCache);

        this._tmpTimesAsString = JSON.stringify(this.props.entity.Times);
        this._icuh.setArrayValues(this._distributable, availableCache);
    }

    private _validate = (data: Array<EntityServiceReportAccomplishedWork>, targetItem: EntityServiceReportAccomplishedWork): boolean => {
        const grouped = ServiceReportUtil.groupTimesPerDay(this.props.entity.Times);
        const distCache = ServiceReportUtil.getAlreadyDistributedTimes(data);
        const availableCache = ServiceReportUtil.getDistributableTimes(grouped, distCache);


        const validationResult = ServiceReportUtil.validateAccomplishedWorks(this.props.entity.Times, data);

        if (!validationResult.valid) {
            NotificationHelper.showErrorMessage(
                ServiceReportUtil.formatAccomplishedValidationErrorMessage(
                    this.props.translations["WebSMS.ServiceReport.Validations.AssignableTimes"],
                    validationResult
                )
            );
            return false;
        }

        return true;
    }


    create = () => {
        const today = new Date();
        const newEntity: EntityServiceReportAccomplishedWork = {
            IsNew: true,
            RecordRight: { CanRead: this.props.entity.RecordRight.CanRead, CanWrite: this.props.entity.RecordRight.CanWrite },
            Datum: today.getFullYear() + "-" + Helper.getTwoDigits(today.getMonth() + 1) + "-" + Helper.getTwoDigits(today.getDate()) + "T00:00:00",
            Isguid: "{" + kendo.guid() + "}",
            IndividualFields: {},
            Changed: false,
            Arbeiten: null,
            MaschNr: null,
            Minuten: null,
            StdAsString: null,
            Pos: null,
            IsWatchable: false,
            IsWatched: false
        };
        this.openWindow(newEntity);
    }

    open = (dataItem: EntityServiceReportAccomplishedWork) => {
        let completionEntity = JSON.parse(JSON.stringify(dataItem));
        completionEntity.IsNew = false;
        completionEntity.RecordRight = { CanRead: this.props.entity.RecordRight.CanRead, CanWrite: this.props.entity.RecordRight.CanWrite };

        this.openWindow(completionEntity);
    }

    openWindow = (entity: EntityServiceReportAccomplishedWork) => {
        const sheet = General.Sheet.Manager.createSheet();
        sheet.setTitle(this.props.translations["WebSMS.ServiceReport.AccomplishedWorks.AccomplishedWorks"]);
        sheet.show(() => {
            const props: ServiceReportCompletionAppProps = {
                context: this.props.context,
                dataSources: this.props.dataSources,
                title: this.props.translations["WebSMS.ServiceReport.AccomplishedWorks.AccomplishedWorks"],
                metadata: this.props.context.metadataCompletion,
                entity: entity,
                isWindow: true,
                onSave: this.handleSave,
                projNr: this.props.entity.Projnr,
                handleMenuSelect: null,
                enableMenuItem: null,
                handleCreateValidator: null,
                handleFieldChange: null,
                handleDataLoaded: null,
                onChange: null,
                afterMount: instance => { this._serviceCompletion = instance; }
            };

            sheet.mountContent(ServiceReportCompletion, props);
        });
    }

    remove = (dataItem: EntityServiceReportAccomplishedWork) => {
        DialogHelper.confirm(this.props.translations["Standard.Msg.Loeschen"]).then(isOK => {
            if (isOK) {
                let index = Helper.findIndex(this.props.entity.AccomplishedWorks, "Isguid", dataItem.Isguid);
                let works = this.props.entity.AccomplishedWorks;
                works.splice(index, 1);
                this._updateRequired = true;
                this.props.onChange({ model: "entity.AccomplishedWorks" }, works);
            }
        });
    }

    handleSave = (entity: EntityServiceReportAccomplishedWork) => {
        let newItem = false;
        const tmpWorks = JSON.parse(JSON.stringify(this.props.entity.AccomplishedWorks));
        const index = Helper.findIndex(tmpWorks, "Isguid", entity.Isguid);
        if (index >= 0) {
            tmpWorks[index] = entity;
        } else {
            newItem = true;
            tmpWorks.push(entity);
        }

        if (this._validate(tmpWorks, entity)) {
            if (newItem) {
                this.props.entity.AccomplishedWorks.push(entity);
            } else {
                let index = Helper.findIndex(this.props.entity.AccomplishedWorks, "Isguid", entity.Isguid);
                this.props.entity.AccomplishedWorks[index] = entity;
            }

            this._updateRequired = true;
            this.props.onChange({ model: "entity.AccomplishedWorks" }, this.props.entity.AccomplishedWorks);
            this._serviceCompletion.close();
        }
    }

    handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: EntityServiceReportAccomplishedWork) => {
        if (type === ToolBarStandardButtonType.NEW) {
            this.create();
        }
        else if (type === ToolBarStandardButtonType.EDIT) {
            this.open(dataItem);
        }
        else if (type == ToolBarStandardButtonType.DELETE) {
            this.remove(dataItem);
        }
    }


    componentDidMount() {
        if (this.props.afterMount) {
            this.props.afterMount(this);
        }
    }

    shouldComponentUpdate(nextProps) {
        if (this._updateRequired) {
            this._updateRequired = false;
            return true;
        } else {
            const newTimesAsString = JSON.stringify(nextProps.entity.Times);
            if (this._tmpTimesAsString !== newTimesAsString) {
                this._tmpTimesAsString = newTimesAsString;
                return true;
            }

            return false;
        }
    }

    render() {
        this._initGridsData();

        let standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: this.props.translations["Standard.Neu"], enabled: this.props.entity.RecordRight.CanWrite });
        standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: this.props.translations["Standard.Editieren"], enabled: this.props.entity.RecordRight.CanWrite });
        standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: this.props.translations["Standard.Loeschen"], enabled: this.props.entity.RecordRight.CanWrite });
        const gridStyle: React.CSSProperties = {
            height: "50%",
            minHeight: "200px",
            //overflowY: "auto" <-- macht IE kaputt
        };

        return (
            <div style={{ height: "100%" }}>
                <div style={gridStyle} >
                    <Grid
                        data={this.props.entity.AccomplishedWorks} options={this.props.context.references.accomplishedWorksGridOptions} id="serviceReportAccomplishedWorks"
                        standardButtons={standardButtons} onClickStandardButton={this.handleClickStandardButton} />
                </div>
                <div style={gridStyle} className="flex-container">
                    <label style={{ marginTop: "10px" }}>{this.props.translations["WebSMS.ServiceReport.AccomplishedWorks.DistributableHours"]}</label>
                    <Grid data={this._distributable} options={this.props.context.references.distributableHoursGridOptions} ref={r => this._distGridRef = r} id="serviceReportDistributable" />
                </div>
            </div>
        );
    }
};

export interface EntityServiceReportAccomplishedWork extends Entity {
    Isguid: string;
    Datum: string;
    Changed: boolean;
    Arbeiten: string;
    MaschNr: string;
    StdAsString: string;
    Minuten: number;
    Pos: number;
}
